<template>
  <div class="new-gift-card">
    <div class="wrapper mt-3" v-if="giftCardsAvailable">
      <h3 class="title2 text-center">{{ title }}</h3>
      <h4 class="caption1 text-center">{{ subtitle }}</h4>
      <div class="carousel-container">
        <CustomCarousel
          :validProducts="storeGiftCards"
          :selectedCardValue="
            cardSelected == undefined ? 0 : cardSelected.Price
          "
          @selecteditem="selectedItem"
          :storemenu="JSON.parse(JSON.stringify(this.storeMenu))"
          :selectedGiftCardId="
            cardSelected == undefined ? null : cardSelected.ProductID
          "
          :card-visible="cardVisible"
          @toggleCardVisible="toggleCardVisible"
        />
      </div>

      <div
        class="container text-center"
        :class="cardVisible && 'product-details'"
        v-if="displayCardSelected"
      >
        <strong>{{ cardSelected.Name }} </strong>
      </div>

      <div class="abacus-oo-giftcards-landing-mainpanel">
        <form @submit.prevent="proceedToConfirmPayment">
          <!-- CardValueSelection -->
          <div class="form-group">
            <h4>Select Card Value</h4>
            <div
              class="d-flex align-center flex-row value-container flex-wrap"
              ref="cardValueRef"
            >
              <div
                v-for="(item, index) in storeGiftCards"
                :key="item.ID"
                class="radio-button col-4 col-sm-3 pl-0 pr-1 m-0"
              >
                <input
                  type="radio"
                  class="btn-check"
                  name="options-outlined"
                  :id="index.toString()"
                  autocomplete="off"
                  ref="valueInputRef"
                />
                <label
                  class="btn"
                  :style="[
                    cardSelected != undefined &&
                    cardSelected.ProductID == item.ProductID
                      ? styles.btn
                      : '',
                  ]"
                  :for="index.toString()"
                  ref="items"
                  @click="onValueClick(item)"
                  >{{ `$${item.Price}.00` }}
                </label>
              </div>
            </div>
          </div>

          <!-- Recipient's Details -->
          <div class="form-group">
            <h4>{{ isMyself ? "Your Details" : "Recipient's Details" }}</h4>
            <div
              class="d-flex justify-content-between align-center details-container"
            >
              <div class="col-12 col-md-6 p-0" :style="{ marginRight: '4px' }">
                <label
                  >From
                  <span :style="{ color: '#FF0000' }">*</span>
                </label>
                <input
                  v-model="messageModelFromName"
                  class="form-control"
                  type="text"
                  required
                  pattern=".*\S+.*"
                />
              </div>

              <div
                class="col-12 col-md-6 p-0"
                :class="isMobile() && 'mt-2'"
                :style="{ marginRight: '4px' }"
              >
                <label
                  >{{ isMyself ? "Your Name" : "Recipient's Name" }}
                  <span :style="{ color: '#FF0000' }">*</span>
                </label>
                <input
                  v-model="messageModelName"
                  class="form-control"
                  type="text"
                  required
                  pattern=".*\S+.*"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 p-0 mt-2" :class="isMobile() && 'mt-2'">
              <label
                >{{ isMyself ? "Your Email" : "Recipient's Email" }}
                <span :style="{ color: '#FF0000' }">*</span></label
              >
              <input
                v-model="messageModelEmail"
                class="form-control"
                type="email"
                required
              />
            </div>
          </div>

          <!-- Gift Message -->
          <div class="form-group">
            <div class="d-flex justify-content-between align-center">
              <h4>Gift Message</h4>
              <label>{{ cRemaining }} Characters Remaining</label>
            </div>

            <textarea
              class="form-control"
              id="floatingTextarea2"
              name="textareaRef"
              rows="5"
              maxlength="56"
              ref="textareaRef"
              v-model="messageModelMessage"
              @keyup="textCounter()"
            ></textarea>
          </div>

          <!-- Purchase Button -->
          <button
            class="purchase-button title5 p-2"
            type="submit"
            :style="styles.btn"
          >
            <span class="p-4">
              <img
                class="purchase_image"
                src="../../../assets/purchase-logo.svg"
                alt="purchase logo"
              />
              Purchase Gift Card</span
            >
          </button>

          <GiftCardFooter />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCarousel from "./CustomCarousel.vue";
import GiftCardFooter from "./GiftCardFooter.vue";
//import { timezones } from "../../../sharedscripts/timezones";
//import { DatePicker } from "v-calendar";
//import { mapMutations, mapActions, mapGetters } from "vuex";
import shared from "../../../sharedscripts/giftcard/details";
import { mapGetters } from "vuex";
import { querySelector } from "../../../sharedscripts/OO_jquery";
export default {
  name: "NewGiftCard",
  components: {
    CustomCarousel,
    //DatePicker,
    GiftCardFooter,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    subtitle: {
      required: true,
      type: String,
    },
    storeid: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["styles"]),
    storeGiftCards: {
      get() {
        return this.$store.getters["newGiftShoppingCart/storeGiftCards"];
      },
    },
    isMyself: {
      get() {
        return !(
          this.$store.getters["newGiftShoppingCart/buyFor"] === "" ||
          this.$store.getters["newGiftShoppingCart/buyFor"] === "gift"
        );
      },
    },
    cardSelected: {
      get() {
        return this.$store.getters["newGiftShoppingCart/cardSelected"];
      },
    },
    buyFor: {
      get() {
        return this.$store.getters["newGiftShoppingCart/buyFor"];
      },
    },
    messageModelFromName: {
      get() {
        return this.$store.getters["newGiftShoppingCart/messageModelFromName"];
      },
      set(value) {
        this.$store.commit(
          "newGiftShoppingCart/setMessageModelFromName",
          value
        );
      },
    },
    messageModelName: {
      get() {
        return this.$store.getters["newGiftShoppingCart/messageModelName"];
      },
      set(value) {
        this.$store.commit("newGiftShoppingCart/setMessageModelName", value);
      },
    },
    messageModelEmail: {
      get() {
        return this.$store.getters["newGiftShoppingCart/messageModelEmail"];
      },
      set(value) {
        this.$store.commit("newGiftShoppingCart/setMessageModelEmail", value);
      },
    },
    messageModelMessage: {
      get() {
        return this.$store.getters["newGiftShoppingCart/messageModelMessage"];
      },
      set(value) {
        this.$store.commit("newGiftShoppingCart/setMessageModelMessage", value);
      },
    },
    storeMenu: {
      get() {
        return this.$store.getters["storeMenu"];
      },
    },
    giftCartItems: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftCartItems"];
      },
    },

    displayCardSelected() {
      // display card only when custom image
      if (!this.cardSelected) return false;
      const cardImg =
        this.cardSelected.PhotoUrl || this.cardSelected.DefaultImageUrl || "";
      return cardImg.includes("http");
    },

    giftCardsAvailable() {
      return this.storeGiftCards && this.storeGiftCards.length > 0;
    },
  },
  data() {
    return {
      cRemaining: 56,
      curTimeOut: undefined,
      product: null,
      productId: null,
      price: null,
      quantity: 1,
      selectedGiftCardId: null,
      cardVisible: false,
    };
  },
  mounted() {
    try {
      // set first giftcard as initial value
      if (this.storeGiftCards && this.storeGiftCards.length > 0) {
        this.onValueClick(this.storeGiftCards[0]);
      }

      if (this.buyFor !== "" && querySelector(".buyfor-container")) {
        Array.from(querySelector(".buyfor-container").children).forEach(
          (valuediv) => valuediv.children[0].removeAttribute("required")
        );
      }

      if (this.cardSelected && querySelector(".value-container")) {
        Array.from(querySelector(".value-container").children).forEach(
          (valuediv) => valuediv.children[0].removeAttribute("required")
        );
      }

      //ToDo Handle the giftCart shopping cart logic later
      // if(this.giftCartItems.length > 0)
      // {
      //   this.populateProduct()
      // }
    } catch (e) {
      console.log({ e });
    }
  },
  methods: {
    ...shared.methods,
    // gettimezones(){
    //   return timezones;
    // },
    useDebounce(callback, delay) {
      const timeoutRef = setTimeout(() => {
        callback();
      }, delay);
      return timeoutRef;
    },
    textCounter() {
      var field = this.$refs.textareaRef.value;
      if (this.cRemaining > 56) {
        field = field.substring(0, 56);
        return false;
      } else {
        var counter = 56 - field.length;
        this.cRemaining = counter;
      }

      // this.cardContentList.value.forEach((cardContent, index) => {
      //   this.cardContentList.value[index] = this.$refs.textareaRef.value;
      // });
      this.setCardContent = this.$refs.textareaRef.value;
    },
    populateProduct() {
      //this.selectedGiftCardId = this.giftCartItems[0].id;
      //this.messageModel = this.giftCartItems[0].message;
      //assign the value for the message rather assign the object directly
      // this.messageModel = {
      //     From: this.giftCartItems[0].message.From,
      //     To: this.giftCartItems[0].message.To,
      //     Message: this.giftCartItems[0].message.Message,
      //     Email: this.giftCartItems[0].message.Email
      // };
    },
    proceedToConfirmPayment() {
      var selectedCard = this.$store.state.newGiftShoppingCart.cardSelected;
      var messageModel = {
        Message: this.$store.state.newGiftShoppingCart.messageModelMessage,
        Email: this.$store.state.newGiftShoppingCart.messageModelEmail,
        From: "",
        To: "",
      };
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isMyself) {
            messageModel.From =
              this.$store.state.newGiftShoppingCart.messageModelName;
            messageModel.To =
              this.$store.state.newGiftShoppingCart.messageModelName;
          } else {
            messageModel.From =
              this.$store.state.newGiftShoppingCart.messageModelFromName;
            messageModel.To =
              this.$store.state.newGiftShoppingCart.messageModelName;
          }

          //2022-05-02
          //confirmed with the manager team that, we keep current workflow
          //only allow customer to purchase one giftcard each time
          //this.$store.dispatch("newGiftShoppingCart/clearGiftCart");

          this.$store.commit("newGiftShoppingCart/Add_GiftcartItem", {
            item: {
              id: selectedCard.ProductID,
              code: selectedCard.ProductCode,
              name: selectedCard.Name,
              description: selectedCard.ShortDescription,
              photoUrl: selectedCard.PhotoUrl,
              localPhotoUrl: selectedCard.DefaultImageUrl,
              buyFor: this.$store.state.newGiftShoppingCart.buyFor,
              tax: selectedCard.TaxRate,
              price: selectedCard.Price,
            },
            quantity: 1,
            message: messageModel,
          });

          this.$router.push({ name: "giftcardConfirmPayment" });
          //TODO
          //this.$refs.addModal.hideModal();
          //mobile
          // this.$nextTick(() => {
          //   this.$parent.closeModal();
          // });
        }
      });
    },
    selectedItem(item) {
      var index = this.storeGiftCards.indexOf(item);
      this.$refs.items[index].click();
    },

    onValueClick(item) {
      this.$store.commit("newGiftShoppingCart/setCardSelected", item);
    },
    setFormBuyFor(value) {
      this.$store.commit("newGiftShoppingCart/setBuyFor", value);
    },
    toggleCardVisible() {
      this.cardVisible = !this.cardVisible;
    },
  },
};
</script>

<style lang="scss" data-gift-card="">
// new gift card
@import "./GiftCard.scss";
</style>
